export enum OpportunityStageEnum {
  PotentialOppIdentified,
  OppQualified,
  ProposedApproach,
  ClientNegReview,
  ClosedWon,
  ClosedUnqualified,
  ClosedProDecline,
  ClosedLost,
}
